import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgVideoIconSecondary from './svgs/VideoIconSecondary.js';
import SvgVideoIcon from './svgs/VideoIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var videoIcon = (props => useIcon(SvgVideoIcon, SvgVideoIconSecondary, props));

export { videoIcon as default };
